/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  BadRequestResponse,
  BulkCreateSpecificationsRequest,
  BulkCreateSpecificationsResponse,
  ForbiddenResponse,
  SaveSpecificationToCatalogResponse,
  ShareTokenWithHeaderResponse,
  SpecificationLookupListResponse,
  SpecificationMappingData,
  SpecificationNotifyUsersResponse,
  SpecificationPreviewListResponse,
  SpecificationPrintRequest,
  SpecificationPrintResponse,
  SpecificationResponse,
  SpecificationsBulkPostV2Params,
  SpecificationsByIdGetV2Params,
  SpecificationsDefaultsGetV2Params,
  SpecificationsDefaultsPostV2Params,
  SpecificationsLookupListGetV2Params,
  SpecificationsSaveToCatalogByIdPostV2Params,
  SpecificationsSharetokenPostV2Params,
  SpecificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2Params,
  SpecificationsUsersToNotifyGetV2Params,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Get specification by Id
 */
export const specificationsByIdGetV2 = (
  id: number,
  params?: SpecificationsByIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SpecificationResponse>(
    { url: `/apix/v2/Specifications/${id}`, method: "GET", params, signal },
    options,
  );
};

export const getSpecificationsByIdGetV2QueryKey = (
  id?: number,
  params?: SpecificationsByIdGetV2Params,
) => {
  return [
    `/apix/v2/Specifications/${id}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSpecificationsByIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof specificationsByIdGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  id: number,
  params?: SpecificationsByIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof specificationsByIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSpecificationsByIdGetV2QueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof specificationsByIdGetV2>>
  > = ({ signal }) =>
    specificationsByIdGetV2(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof specificationsByIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SpecificationsByIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof specificationsByIdGetV2>>
>;
export type SpecificationsByIdGetV2QueryError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary Get specification by Id
 */

export function useSpecificationsByIdGetV2<
  TData = Awaited<ReturnType<typeof specificationsByIdGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  id: number,
  params?: SpecificationsByIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof specificationsByIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSpecificationsByIdGetV2QueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Get a specific snapshot's content for a specification
 */
export const specificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2 = (
  externalId: string,
  snapshotExternalId: string,
  params?: SpecificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SpecificationResponse>(
    {
      url: `/apix/v2/Specifications/${externalId}/snapshot/${snapshotExternalId}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getSpecificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2QueryKey =
  (
    externalId?: string,
    snapshotExternalId?: string,
    params?: SpecificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2Params,
  ) => {
    return [
      `/apix/v2/Specifications/${externalId}/snapshot/${snapshotExternalId}`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getSpecificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof specificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2
      >
    >,
    TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  >(
    externalId: string,
    snapshotExternalId: string,
    params?: SpecificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2Params,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof specificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getSpecificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2QueryKey(
        externalId,
        snapshotExternalId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof specificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2
        >
      >
    > = ({ signal }) =>
      specificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2(
        externalId,
        snapshotExternalId,
        params,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(externalId && snapshotExternalId),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof specificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type SpecificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof specificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2
      >
    >
  >;
export type SpecificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2QueryError =
  ErrorType<BadRequestResponse | ForbiddenResponse>;

/**
 * @summary Get a specific snapshot's content for a specification
 */

export function useSpecificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2<
  TData = Awaited<
    ReturnType<
      typeof specificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2
    >
  >,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  externalId: string,
  snapshotExternalId: string,
  params?: SpecificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof specificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2
        >
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getSpecificationsSnapshotByExternalIdAndSnapshotExternalIdGetV2QueryOptions(
      externalId,
      snapshotExternalId,
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Get default specification info for a job
 */
export const specificationsDefaultsGetV2 = (
  params?: SpecificationsDefaultsGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SpecificationResponse>(
    { url: `/apix/v2/Specifications/defaults`, method: "GET", params, signal },
    options,
  );
};

export const getSpecificationsDefaultsGetV2QueryKey = (
  params?: SpecificationsDefaultsGetV2Params,
) => {
  return [
    `/apix/v2/Specifications/defaults`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSpecificationsDefaultsGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof specificationsDefaultsGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  params?: SpecificationsDefaultsGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof specificationsDefaultsGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSpecificationsDefaultsGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof specificationsDefaultsGetV2>>
  > = ({ signal }) =>
    specificationsDefaultsGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof specificationsDefaultsGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SpecificationsDefaultsGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof specificationsDefaultsGetV2>>
>;
export type SpecificationsDefaultsGetV2QueryError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary Get default specification info for a job
 */

export function useSpecificationsDefaultsGetV2<
  TData = Awaited<ReturnType<typeof specificationsDefaultsGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  params?: SpecificationsDefaultsGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof specificationsDefaultsGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSpecificationsDefaultsGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Get default specification info for a job with mapping data
 */
export const specificationsDefaultsPostV2 = (
  specificationMappingData: BodyType<SpecificationMappingData>,
  params?: SpecificationsDefaultsPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SpecificationResponse>(
    {
      url: `/apix/v2/Specifications/defaults`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: specificationMappingData,
      params,
      signal,
    },
    options,
  );
};

export const getSpecificationsDefaultsPostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof specificationsDefaultsPostV2>>,
    TError,
    {
      data: BodyType<SpecificationMappingData>;
      params?: SpecificationsDefaultsPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof specificationsDefaultsPostV2>>,
  TError,
  {
    data: BodyType<SpecificationMappingData>;
    params?: SpecificationsDefaultsPostV2Params;
  },
  TContext
> => {
  const mutationKey = ["specificationsDefaultsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof specificationsDefaultsPostV2>>,
    {
      data: BodyType<SpecificationMappingData>;
      params?: SpecificationsDefaultsPostV2Params;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return specificationsDefaultsPostV2(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SpecificationsDefaultsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof specificationsDefaultsPostV2>>
>;
export type SpecificationsDefaultsPostV2MutationBody =
  BodyType<SpecificationMappingData>;
export type SpecificationsDefaultsPostV2MutationError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary Get default specification info for a job with mapping data
 */
export const useSpecificationsDefaultsPostV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof specificationsDefaultsPostV2>>,
    TError,
    {
      data: BodyType<SpecificationMappingData>;
      params?: SpecificationsDefaultsPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof specificationsDefaultsPostV2>>,
  TError,
  {
    data: BodyType<SpecificationMappingData>;
    params?: SpecificationsDefaultsPostV2Params;
  },
  TContext
> => {
  const mutationOptions =
    getSpecificationsDefaultsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Bulk create specifications from source entities.
Currently only officially supports ProposalFormatItem as the source entity type. Attachment copying
and bidirectional entity record linking are ProposalFormatItem-specific; other source types
will create specifications and entity record links but skip these PFI specific operations.
 */
export const specificationsBulkPostV2 = (
  bulkCreateSpecificationsRequest: BodyType<BulkCreateSpecificationsRequest>,
  params?: SpecificationsBulkPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BulkCreateSpecificationsResponse>(
    {
      url: `/apix/v2/Specifications/bulk`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: bulkCreateSpecificationsRequest,
      params,
      signal,
    },
    options,
  );
};

export const getSpecificationsBulkPostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof specificationsBulkPostV2>>,
    TError,
    {
      data: BodyType<BulkCreateSpecificationsRequest>;
      params?: SpecificationsBulkPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof specificationsBulkPostV2>>,
  TError,
  {
    data: BodyType<BulkCreateSpecificationsRequest>;
    params?: SpecificationsBulkPostV2Params;
  },
  TContext
> => {
  const mutationKey = ["specificationsBulkPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof specificationsBulkPostV2>>,
    {
      data: BodyType<BulkCreateSpecificationsRequest>;
      params?: SpecificationsBulkPostV2Params;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return specificationsBulkPostV2(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SpecificationsBulkPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof specificationsBulkPostV2>>
>;
export type SpecificationsBulkPostV2MutationBody =
  BodyType<BulkCreateSpecificationsRequest>;
export type SpecificationsBulkPostV2MutationError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary Bulk create specifications from source entities.
Currently only officially supports ProposalFormatItem as the source entity type. Attachment copying
and bidirectional entity record linking are ProposalFormatItem-specific; other source types
will create specifications and entity record links but skip these PFI specific operations.
 */
export const useSpecificationsBulkPostV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof specificationsBulkPostV2>>,
    TError,
    {
      data: BodyType<BulkCreateSpecificationsRequest>;
      params?: SpecificationsBulkPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof specificationsBulkPostV2>>,
  TError,
  {
    data: BodyType<BulkCreateSpecificationsRequest>;
    params?: SpecificationsBulkPostV2Params;
  },
  TContext
> => {
  const mutationOptions = getSpecificationsBulkPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Save a job-level specification up to the company catalog (the builder's general job).
Creates a new, independent catalog spec — viewing permissions, version history and comments are not
carried over, the title is deduplicated against the catalog, and attachments are copied.
 */
export const specificationsSaveToCatalogByIdPostV2 = (
  id: number,
  params?: SpecificationsSaveToCatalogByIdPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SaveSpecificationToCatalogResponse>(
    {
      url: `/apix/v2/Specifications/${id}/save-to-catalog`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getSpecificationsSaveToCatalogByIdPostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof specificationsSaveToCatalogByIdPostV2>>,
    TError,
    { id: number; params?: SpecificationsSaveToCatalogByIdPostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof specificationsSaveToCatalogByIdPostV2>>,
  TError,
  { id: number; params?: SpecificationsSaveToCatalogByIdPostV2Params },
  TContext
> => {
  const mutationKey = ["specificationsSaveToCatalogByIdPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof specificationsSaveToCatalogByIdPostV2>>,
    { id: number; params?: SpecificationsSaveToCatalogByIdPostV2Params }
  > = (props) => {
    const { id, params } = props ?? {};

    return specificationsSaveToCatalogByIdPostV2(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SpecificationsSaveToCatalogByIdPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof specificationsSaveToCatalogByIdPostV2>>
>;

export type SpecificationsSaveToCatalogByIdPostV2MutationError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary Save a job-level specification up to the company catalog (the builder's general job).
Creates a new, independent catalog spec — viewing permissions, version history and comments are not
carried over, the title is deduplicated against the catalog, and attachments are copied.
 */
export const useSpecificationsSaveToCatalogByIdPostV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof specificationsSaveToCatalogByIdPostV2>>,
    TError,
    { id: number; params?: SpecificationsSaveToCatalogByIdPostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof specificationsSaveToCatalogByIdPostV2>>,
  TError,
  { id: number; params?: SpecificationsSaveToCatalogByIdPostV2Params },
  TContext
> => {
  const mutationOptions =
    getSpecificationsSaveToCatalogByIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Get all specification lookup list data for a job
 */
export const specificationsLookupListGetV2 = (
  params?: SpecificationsLookupListGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SpecificationLookupListResponse>(
    {
      url: `/apix/v2/Specifications/lookup-list`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getSpecificationsLookupListGetV2QueryKey = (
  params?: SpecificationsLookupListGetV2Params,
) => {
  return [
    `/apix/v2/Specifications/lookup-list`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSpecificationsLookupListGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof specificationsLookupListGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  params?: SpecificationsLookupListGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof specificationsLookupListGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSpecificationsLookupListGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof specificationsLookupListGetV2>>
  > = ({ signal }) =>
    specificationsLookupListGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof specificationsLookupListGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SpecificationsLookupListGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof specificationsLookupListGetV2>>
>;
export type SpecificationsLookupListGetV2QueryError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary Get all specification lookup list data for a job
 */

export function useSpecificationsLookupListGetV2<
  TData = Awaited<ReturnType<typeof specificationsLookupListGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  params?: SpecificationsLookupListGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof specificationsLookupListGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSpecificationsLookupListGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Get the active internal users/clients/subs assigned to a job who are eligible to be
selected as explicit publish/update notification recipients, grouped by login type.
 */
export const specificationsUsersToNotifyGetV2 = (
  params?: SpecificationsUsersToNotifyGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SpecificationNotifyUsersResponse>(
    {
      url: `/apix/v2/Specifications/users-to-notify`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getSpecificationsUsersToNotifyGetV2QueryKey = (
  params?: SpecificationsUsersToNotifyGetV2Params,
) => {
  return [
    `/apix/v2/Specifications/users-to-notify`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSpecificationsUsersToNotifyGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof specificationsUsersToNotifyGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  params?: SpecificationsUsersToNotifyGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof specificationsUsersToNotifyGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSpecificationsUsersToNotifyGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof specificationsUsersToNotifyGetV2>>
  > = ({ signal }) =>
    specificationsUsersToNotifyGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof specificationsUsersToNotifyGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SpecificationsUsersToNotifyGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof specificationsUsersToNotifyGetV2>>
>;
export type SpecificationsUsersToNotifyGetV2QueryError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary Get the active internal users/clients/subs assigned to a job who are eligible to be
selected as explicit publish/update notification recipients, grouped by login type.
 */

export function useSpecificationsUsersToNotifyGetV2<
  TData = Awaited<ReturnType<typeof specificationsUsersToNotifyGetV2>>,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  params?: SpecificationsUsersToNotifyGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof specificationsUsersToNotifyGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSpecificationsUsersToNotifyGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Load specifications for printing
 */
export const specificationsPrintPostV2 = (
  specificationPrintRequest: BodyType<SpecificationPrintRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SpecificationPrintResponse>(
    {
      url: `/apix/v2/Specifications/print`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: specificationPrintRequest,
      signal,
    },
    options,
  );
};

export const getSpecificationsPrintPostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof specificationsPrintPostV2>>,
    TError,
    { data: BodyType<SpecificationPrintRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof specificationsPrintPostV2>>,
  TError,
  { data: BodyType<SpecificationPrintRequest> },
  TContext
> => {
  const mutationKey = ["specificationsPrintPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof specificationsPrintPostV2>>,
    { data: BodyType<SpecificationPrintRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return specificationsPrintPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SpecificationsPrintPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof specificationsPrintPostV2>>
>;
export type SpecificationsPrintPostV2MutationBody =
  BodyType<SpecificationPrintRequest>;
export type SpecificationsPrintPostV2MutationError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary Load specifications for printing
 */
export const useSpecificationsPrintPostV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof specificationsPrintPostV2>>,
    TError,
    { data: BodyType<SpecificationPrintRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof specificationsPrintPostV2>>,
  TError,
  { data: BodyType<SpecificationPrintRequest> },
  TContext
> => {
  const mutationOptions = getSpecificationsPrintPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Stability Level**: `stable`
 * @summary Gets specifications linked to an entity via share token (external access).
The share token determines the entity type automatically.
Currently supports: PurchaseOrder. Extensible for Bids, ChangeOrders, etc.
 */
export const specificationsEntityExternalByShareTokenGetV2 = (
  shareToken: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SpecificationPreviewListResponse>(
    {
      url: `/apix/v2/Specifications/entity/external/${shareToken}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getSpecificationsEntityExternalByShareTokenGetV2QueryKey = (
  shareToken?: string,
) => {
  return [`/apix/v2/Specifications/entity/external/${shareToken}`] as const;
};

export const getSpecificationsEntityExternalByShareTokenGetV2QueryOptions = <
  TData = Awaited<
    ReturnType<typeof specificationsEntityExternalByShareTokenGetV2>
  >,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  shareToken: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof specificationsEntityExternalByShareTokenGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSpecificationsEntityExternalByShareTokenGetV2QueryKey(shareToken);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof specificationsEntityExternalByShareTokenGetV2>>
  > = ({ signal }) =>
    specificationsEntityExternalByShareTokenGetV2(
      shareToken,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!shareToken,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof specificationsEntityExternalByShareTokenGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SpecificationsEntityExternalByShareTokenGetV2QueryResult =
  NonNullable<
    Awaited<ReturnType<typeof specificationsEntityExternalByShareTokenGetV2>>
  >;
export type SpecificationsEntityExternalByShareTokenGetV2QueryError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary Gets specifications linked to an entity via share token (external access).
The share token determines the entity type automatically.
Currently supports: PurchaseOrder. Extensible for Bids, ChangeOrders, etc.
 */

export function useSpecificationsEntityExternalByShareTokenGetV2<
  TData = Awaited<
    ReturnType<typeof specificationsEntityExternalByShareTokenGetV2>
  >,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  shareToken: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof specificationsEntityExternalByShareTokenGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getSpecificationsEntityExternalByShareTokenGetV2QueryOptions(
      shareToken,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `stable`
 * @summary Get all published specifications for external sharing by share token.
Only returns specifications with published status (shared with owners or subs), excludes drafts.
 */
export const specificationsExternalSpecificationsByShareTokenGetV2 = (
  shareToken: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SpecificationLookupListResponse>(
    {
      url: `/apix/v2/Specifications/external/${shareToken}/Specifications`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getSpecificationsExternalSpecificationsByShareTokenGetV2QueryKey =
  (shareToken?: string) => {
    return [
      `/apix/v2/Specifications/external/${shareToken}/Specifications`,
    ] as const;
  };

export const getSpecificationsExternalSpecificationsByShareTokenGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof specificationsExternalSpecificationsByShareTokenGetV2>
    >,
    TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  >(
    shareToken: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof specificationsExternalSpecificationsByShareTokenGetV2
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getSpecificationsExternalSpecificationsByShareTokenGetV2QueryKey(
        shareToken,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof specificationsExternalSpecificationsByShareTokenGetV2>
      >
    > = ({ signal }) =>
      specificationsExternalSpecificationsByShareTokenGetV2(
        shareToken,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shareToken,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof specificationsExternalSpecificationsByShareTokenGetV2>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type SpecificationsExternalSpecificationsByShareTokenGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof specificationsExternalSpecificationsByShareTokenGetV2>
    >
  >;
export type SpecificationsExternalSpecificationsByShareTokenGetV2QueryError =
  ErrorType<BadRequestResponse | ForbiddenResponse>;

/**
 * @summary Get all published specifications for external sharing by share token.
Only returns specifications with published status (shared with owners or subs), excludes drafts.
 */

export function useSpecificationsExternalSpecificationsByShareTokenGetV2<
  TData = Awaited<
    ReturnType<typeof specificationsExternalSpecificationsByShareTokenGetV2>
  >,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  shareToken: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof specificationsExternalSpecificationsByShareTokenGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getSpecificationsExternalSpecificationsByShareTokenGetV2QueryOptions(
      shareToken,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `stable`
 * @summary Get a specific specification's details for external sharing by share token.
Returns 404 if specification is not published.
 */
export const specificationsExternalSpecificationsByShareTokenAndExternalIdGetV2 =
  (
    shareToken: string,
    externalId: string,
    options?: SecondParameter<typeof apixHandler>,
    signal?: AbortSignal,
  ) => {
    return apixHandler<SpecificationResponse>(
      {
        url: `/apix/v2/Specifications/external/${shareToken}/Specifications/${externalId}`,
        method: "GET",
        signal,
      },
      options,
    );
  };

export const getSpecificationsExternalSpecificationsByShareTokenAndExternalIdGetV2QueryKey =
  (shareToken?: string, externalId?: string) => {
    return [
      `/apix/v2/Specifications/external/${shareToken}/Specifications/${externalId}`,
    ] as const;
  };

export const getSpecificationsExternalSpecificationsByShareTokenAndExternalIdGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof specificationsExternalSpecificationsByShareTokenAndExternalIdGetV2
      >
    >,
    TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  >(
    shareToken: string,
    externalId: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof specificationsExternalSpecificationsByShareTokenAndExternalIdGetV2
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getSpecificationsExternalSpecificationsByShareTokenAndExternalIdGetV2QueryKey(
        shareToken,
        externalId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof specificationsExternalSpecificationsByShareTokenAndExternalIdGetV2
        >
      >
    > = ({ signal }) =>
      specificationsExternalSpecificationsByShareTokenAndExternalIdGetV2(
        shareToken,
        externalId,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(shareToken && externalId),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof specificationsExternalSpecificationsByShareTokenAndExternalIdGetV2
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type SpecificationsExternalSpecificationsByShareTokenAndExternalIdGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof specificationsExternalSpecificationsByShareTokenAndExternalIdGetV2
      >
    >
  >;
export type SpecificationsExternalSpecificationsByShareTokenAndExternalIdGetV2QueryError =
  ErrorType<BadRequestResponse | ForbiddenResponse>;

/**
 * @summary Get a specific specification's details for external sharing by share token.
Returns 404 if specification is not published.
 */

export function useSpecificationsExternalSpecificationsByShareTokenAndExternalIdGetV2<
  TData = Awaited<
    ReturnType<
      typeof specificationsExternalSpecificationsByShareTokenAndExternalIdGetV2
    >
  >,
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
>(
  shareToken: string,
  externalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof specificationsExternalSpecificationsByShareTokenAndExternalIdGetV2
        >
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getSpecificationsExternalSpecificationsByShareTokenAndExternalIdGetV2QueryOptions(
      shareToken,
      externalId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Generate or retrieve a share token for the specification book
 */
export const specificationsSharetokenPostV2 = (
  params?: SpecificationsSharetokenPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ShareTokenWithHeaderResponse>(
    {
      url: `/apix/v2/Specifications/sharetoken`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getSpecificationsSharetokenPostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof specificationsSharetokenPostV2>>,
    TError,
    { params?: SpecificationsSharetokenPostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof specificationsSharetokenPostV2>>,
  TError,
  { params?: SpecificationsSharetokenPostV2Params },
  TContext
> => {
  const mutationKey = ["specificationsSharetokenPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof specificationsSharetokenPostV2>>,
    { params?: SpecificationsSharetokenPostV2Params }
  > = (props) => {
    const { params } = props ?? {};

    return specificationsSharetokenPostV2(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SpecificationsSharetokenPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof specificationsSharetokenPostV2>>
>;

export type SpecificationsSharetokenPostV2MutationError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

/**
 * @summary Generate or retrieve a share token for the specification book
 */
export const useSpecificationsSharetokenPostV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof specificationsSharetokenPostV2>>,
    TError,
    { params?: SpecificationsSharetokenPostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof specificationsSharetokenPostV2>>,
  TError,
  { params?: SpecificationsSharetokenPostV2Params },
  TContext
> => {
  const mutationOptions =
    getSpecificationsSharetokenPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
